import { withStyles } from '@material-ui/core/styles';
import { FormControlLabel } from '@material-ui/core';

export const StyledRadio = withStyles(() => ({
  label: { fontSize: 14 },
}))(FormControlLabel);
